
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

interface TopConsumer {
  name: string;
  location: string;
  consumption: number;
  change: number;
}

interface TopConsumersCardProps {
  consumers: TopConsumer[];
}

const TopConsumersCard: React.FC<TopConsumersCardProps> = ({ consumers }) => {
  return (
    <Card className="col-span-1 lg:col-span-2">
      <CardHeader>
        <CardTitle>Top Water Consumers</CardTitle>
        <CardDescription>Facilities with highest water consumption</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {consumers.map((consumer, index) => (
            <div key={index} className="flex items-center border-b pb-4 last:border-0 last:pb-0">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-100 flex items-center justify-center mr-3">
                <span className="text-cyan-600 font-medium text-sm">{index + 1}</span>
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-medium">{consumer.name}</h4>
                <p className="text-xs text-muted-foreground">{consumer.location}</p>
              </div>
              <div className="text-right">
                <div className="text-sm font-medium">{consumer.consumption} m³</div>
                <div className={`text-xs ${consumer.change > 0 ? 'text-red-500' : 'text-green-500'}`}>
                  {consumer.change > 0 ? '+' : ''}{consumer.change}%
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default TopConsumersCard;
